var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23.12 0H1.88A1.88 1.88 0 000 1.88v12.51a1.88 1.88 0 001.88 1.88h9.57v1.25H5.2a1.25 1.25 0 100 2.5h15a1.25 1.25 0 000-2.5H14v-1.25h9.17A1.88 1.88 0 0025 14.39V1.88A1.88 1.88 0 0023.12 0zm-.62 13.76h-20V2.5h20z","fill":"currentColor  "}})
}
var staticRenderFns = []

export { render, staticRenderFns }